import React from "react"
import "./RoundingMonitorLogo.scss"
import image from "./rounding-monitor-logo.svg"
import { getResolutionHeight } from "../../helpers/sharedHelperFunctions"

const RoundingMonitorLogo = () => {
  return (
    <div className="rm-logo">
      <img
        className={`image-width-${getResolutionHeight()}`}
        alt="SwipeSense Logo"
        src={image}
      />
    </div>
  )
}

export default RoundingMonitorLogo
